import { render, staticRenderFns } from "./mallCouponManage.vue?vue&type=template&id=ff373cb8&scoped=true"
import script from "./mallCouponManage.vue?vue&type=script&lang=js"
export * from "./mallCouponManage.vue?vue&type=script&lang=js"
import style0 from "./mallCouponManage.vue?vue&type=style&index=0&id=ff373cb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff373cb8",
  null
  
)

export default component.exports